'use strict';

class MassDunning {
  constructor($scope, dunningService, I18N, Notification) {
    this.$scope = $scope;
    this.dunningService = dunningService;
    this.I18N = I18N;
    this.Notification = Notification;
  }

  $onInit() {
    this.alert = [];

    this.total = 0;
    this.invoices = {};

    this.loading = false;

    this.years = [];
    this.year = null;
    this.month = null;
    this.type = '';
    this.offset = 0;
    this.limit = 25;
    this.currentPage = 1;

    this.selectedInvoiceNos = [];
    this.allSelected = false;

    this.dunningFee = false;
    this.collectionWarning = false;
    this.interests = false;
    this.dunningText = this.I18N.dunning.text;

    this.initYears();
    this.$scope.$watchGroup([
      '$ctrl.year',
      '$ctrl.type',
      '$ctrl.month',
      '$ctrl.offset',
      '$ctrl.limit',
      '$ctrl.currentPage'
    ], () => {
      this.load();
    });

    this.load();
  }

  initYears() {
    let currentYear = new Date().getFullYear();
    this.years.push(currentYear);
    for (let i = 1; i < 10; i++) {
      this.years.push(currentYear - i);
    }
  }

  /**
   * Load dunnable invoices
   */
  load() {
    this.allSelected = false;

    if (this.year === null || this.year === '') {
      this.month = null;
    }

    let params = {
      offset: this.offset,
      limit: this.limit,
      year: this.year,
      month: this.month
    };

    if (this.type) {
      params.dunningType = this.type;
    }

    this.dunningService.list(params)
      .then((resp) => {
        if (this.alert.type === 'alert') {
          this.alert = [];
        }

        this.invoices = resp.data.invoices;
        this.total = resp.data.total;
      });
  }

  /**
   * Number of pages based by limit per page
   *
   * @returns {Number} Number of pages
   */
  numberOfPages() {
    return Math.ceil(this.total / this.limit);
  }

  isSelected(invoiceNumber) {
    return this.selectedInvoiceNos.indexOf(invoiceNumber) !== -1;
  }

  selectHandler(invoiceNumber) {
    var index = this.selectedInvoiceNos.indexOf(invoiceNumber);

    if (index !== -1) {
      this.selectedInvoiceNos.splice(index, 1);
    } else {
      this.selectedInvoiceNos.push(invoiceNumber);
    }
  }

  /**
   * Toggle selection of all items
   */
  toggleSelection() {
    if (this.allSelected) {
      this.invoices.forEach((item) => {
        if (!this.isSelected(item.invoiceNumber)) {
          this.selectedInvoiceNos.push(item.invoiceNumber);
        }
      });
    } else {
      this.invoices.forEach((item) => {
        var index = this.selectedInvoiceNos.indexOf(item.invoiceNumber);
        if (index !== -1) {
          this.selectedInvoiceNos.splice(index, 1);
        }
      });
    }
  }

  /**
   * Limit visible invoices
   *
   * @param {Number} limit
   */
  changeLimit(limit) {
    this.offset = 0;
    this.limit = limit;
    this.currentPage = 1;
  }

  /**
   * Go to next page by setting offset
   */
  nextPage() {
    this.offset += this.limit;
    this.currentPage += 1;
  }

  /**
   * Go to previous page by setting offset
   */
  prevPage() {
    this.offset -= this.limit;
    this.currentPage -= 1;
  }

  /**
   * Send dunnable invoices
   */
  send() {
    this.loading = true;

    //remove duplicates
    let unique = this.selectedInvoiceNos.filter((a, b) => this.selectedInvoiceNos.indexOf(a) === b);

    let invoiceNos = [];

    unique.forEach((item) => {
      invoiceNos.push({invoiceNo: item});
    }, this);

    if (invoiceNos.length) {
      this.dunningService.send(
        {
          invoiceNos: invoiceNos,
          dunningFee: this.dunningFee,
          interests: this.interests,
          collectionWarning: this.collectionWarning,
          dunningText: this.dunningText
        })
        .then((resp) => {
          this.loading = false;
          this.reset();
          this.Notification.success(this.I18N.dunning.sent);
        })
        .catch(() => {
          this.loading = false;
          this.Notification.error(this.I18N.dunning.error.noSelection);
        });
    } else {
      this.loading = false;
      this.Notification.error(this.I18N.dunning.error.noSelection);
    }
  }

  /**
   * Reset state to default
   */
  reset() {
    this.year = null;
    this.type = '';
    this.month = null;
    this.selectedInvoiceNos = [];
    this.total = 0;
    this.allSelected = false;
    this.dunningFee = false;
    this.collectionWarning = false;
    this.interests = false;
    this.dunningText = 'Vi kan dessverre ikke se å ha mottatt deres betaling for denne regningen.';

    if (this.alert.type === 'alert') {
      this.alert = [];
    }

    this.offset = 0;
    this.limit = 25;
    this.currentPage = 1;

    this.load();
    this.numberOfPages();
  }
}

MassDunning.$inject = ['$scope', 'dunningService', 'I18N', 'Notification'];

const massDunning = {
  controller: MassDunning,
  templateUrl: 'dunning/mass.html'
};

angular
  .module('SendRegning')
  .component('massDunning', massDunning)
  .config(($routeProvider) => {
    $routeProvider
      .when('/massepurring', {
        title: 'Massepurring',
        template: '<mass-dunning/>',
        secure: true
      });
  });
